/**
 * @typedef {Object} TeamMember
 * @property {string} id            Stable key, unique across all sections.
 * @property {string} name          Display name, exactly as it should appear on the card.
 * @property {string} title         Role shown after the name.
 * @property {string} photo         Path relative to public/, e.g. images/paw-staff-photos/Son-Fang.png
 * @property {string[]} description One entry per line shown under the title.
 */

/**
 * @typedef {Object} TeamSection
 * @property {string} id
 * @property {string} title
 * @property {TeamMember[]} members
 */

const PHOTO_DIR = 'images/paw-staff-photos';

const RUA_GRADUATE = 'Graduate from Royal University of Agriculture, Phnom Penh in Veterinary Medicine';
const RUA_UNDERGRADUATE = 'Undergraduate from Royal University of Agriculture, Phnom Penh in Veterinary Medicine';
const ITC_UNDERGRADUATE = 'Undergraduate, Institute of Technology of Cambodia, Phnom Penh';

const photo = (fileName) => `${PHOTO_DIR}/${fileName}`;

/** @type {TeamMember[]} */
export const STAFF_MEMBERS = [
  {
    id: 'tim-sovicha',
    name: 'Dr Tim Sovicha',
    title: 'Veterinary Clinic Lead',
    photo: photo('Dr-Tim-Sovicha.png'),
    description: [RUA_GRADUATE, 'Specializes in Dermatology'],
  },
  {
    id: 'son-fang',
    name: 'Son Fang',
    title: 'Veterinary Technician',
    photo: photo('Son-Fang.png'),
    description: [RUA_UNDERGRADUATE, 'Our in-house Groomer'],
  },
  {
    id: 'koem-sengheang',
    name: 'Koem SengHeang',
    title: 'Veterinary Technician',
    photo: photo('Koem-SengHeang.png'),
    description: [RUA_GRADUATE, 'Specializes in Gastrointestinal parasites'],
  },
  {
    id: 'mang-sakadavann',
    name: 'Mang Sakadavann',
    title: 'Veterinary Assistant',
    photo: photo('Mang-Sakadavann.png'),
    description: [RUA_UNDERGRADUATE],
  },
  {
    id: 'sok-hour-uch',
    name: 'Sok Hour Uch',
    title: 'IT Intern',
    photo: photo('Sok-Hour-Uch.png'),
    description: [ITC_UNDERGRADUATE],
  },
  {
    id: 'chin-hongnyheng',
    name: 'Chin Hongnyheng',
    title: 'IT Intern',
    photo: photo('Chin-Hongnyheng.jpg'),
    description: [ITC_UNDERGRADUATE],
  },
];

/** @type {TeamMember[]} */
export const ALUMNI_MEMBERS = [
  {
    id: 'tacoma-pich',
    name: 'Tacoma Pich',
    title: 'Veterinary Doctor',
    photo: photo('Tacoma-Pich.png'),
    description: [RUA_GRADUATE, 'Specializes in Surgery'],
  },
  {
    id: 'vandy-sok',
    name: 'Vandy Sok',
    title: 'Veterinary Technician',
    photo: photo('Vandy-Sok.png'),
    description: [RUA_GRADUATE, 'Specializes in Cancer Treatment'],
  },
  {
    id: 'sreymouy-muok',
    name: 'Sreymouy Muok',
    title: 'Veterinary Technician',
    photo: photo('Sreymouy-Muok.png'),
    description: [RUA_GRADUATE, 'Specializes in Dermatology'],
  },
  {
    id: 'yem-semnang',
    name: 'Yem Semnang',
    title: 'Veterinary Technician',
    photo: photo('Yem-Semnang.png'),
    description: [RUA_GRADUATE, 'Specializes in Internal Medicine'],
  },
  {
    id: 'sorn-thoeurn',
    name: 'Sorn Thoeurn',
    title: 'Veterinary Assistant',
    photo: photo('Sorn-Thoeurn.png'),
    description: [RUA_GRADUATE],
  },
  {
    id: 'dariya-chan',
    name: 'Dariya Chan',
    title: 'Veterinary Assistant',
    photo: photo('Dariya-Chan.png'),
    description: [RUA_UNDERGRADUATE],
  },
  {
    id: 'leakna-cheab',
    name: 'Leakna Cheab',
    title: 'Veterinary Assistant',
    photo: photo('Leakna-Cheab.png'),
    description: [RUA_UNDERGRADUATE],
  },
  {
    id: 'thai-vicheara',
    name: 'Thai Vicheara',
    title: 'Veterinary Assistant',
    photo: photo('Thai-Vicheara.png'),
    description: [RUA_UNDERGRADUATE],
  },
  {
    id: 'naieang-srun',
    name: 'NaiEang Srun',
    title: 'IT Intern',
    photo: photo('NaiEang-Srun.png'),
    description: [ITC_UNDERGRADUATE],
  },
];

/** @type {TeamSection[]} */
export const TEAM_SECTIONS = [
  { id: 'staff', title: 'Our Staff', members: STAFF_MEMBERS },
  { id: 'alumni', title: 'Our Staff Alumni', members: ALUMNI_MEMBERS },
];
